import type { Badge } from "./_model";

export let badge: Badge = null;
export const _internal = {
  setBadge: (value: Badge) => (badge = value),
};
export const actions = {
  getBadge: () => badge,
  getBadgeStyle: (props: { track: string | null }) => {
    if (badge?.tracks == undefined) {
      return null;
    }
    let track = badge.tracks[props.track];
    if (track == undefined) {
      track = badge.tracks["no track"];
    }
    return {
      style: {
        "background-color": track.bg,
        color: track.text,
      },
    };
  },
};
